export default {
  'company introduction': '公司介绍',


}



// WEBPACK FOOTER //
// ./src/comm/i18n/zh-hans/index.js